export default "__VITE_ASSET__IwghnqMW__"